/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListSkillTagsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSkillTagsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSkillTagsSecurity = {
  option1?: ListSkillTagsSecurityOption1 | undefined;
  option2?: ListSkillTagsSecurityOption2 | undefined;
};

export type ListSkillTagsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListSkillTagsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSkillTagsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListSkillTagsSecurityOption1$Outbound,
  ListSkillTagsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSkillTagsSecurityOption1ToJSON(
  listSkillTagsSecurityOption1: ListSkillTagsSecurityOption1,
): string {
  return JSON.stringify(
    ListSkillTagsSecurityOption1$outboundSchema.parse(
      listSkillTagsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSkillTagsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSkillTagsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListSkillTagsSecurityOption2$Outbound,
  ListSkillTagsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listSkillTagsSecurityOption2ToJSON(
  listSkillTagsSecurityOption2: ListSkillTagsSecurityOption2,
): string {
  return JSON.stringify(
    ListSkillTagsSecurityOption2$outboundSchema.parse(
      listSkillTagsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSkillTagsSecurity$Outbound = {
  Option1?: ListSkillTagsSecurityOption1$Outbound | undefined;
  Option2?: ListSkillTagsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSkillTagsSecurity$outboundSchema: z.ZodMiniType<
  ListSkillTagsSecurity$Outbound,
  ListSkillTagsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSkillTagsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSkillTagsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSkillTagsSecurityToJSON(
  listSkillTagsSecurity: ListSkillTagsSecurity,
): string {
  return JSON.stringify(
    ListSkillTagsSecurity$outboundSchema.parse(listSkillTagsSecurity),
  );
}

/** @internal */
export type ListSkillTagsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSkillTagsRequest$outboundSchema: z.ZodMiniType<
  ListSkillTagsRequest$Outbound,
  ListSkillTagsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSkillTagsRequestToJSON(
  listSkillTagsRequest: ListSkillTagsRequest,
): string {
  return JSON.stringify(
    ListSkillTagsRequest$outboundSchema.parse(listSkillTagsRequest),
  );
}
